export default __webpack_public_path__ + "static/media/1320.aa11addc.png";